var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "mobile-page", style: _vm.boxStyle }, [
        _c(
          "div",
          { staticClass: "advert" },
          [
            _vm.style === 0
              ? _vm._l(_vm.picList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "advertItem01 acea-row" },
                    [
                      item.image
                        ? _c("img", {
                            staticClass: "img-style",
                            class:
                              item.radioVal === "0"
                                ? "stretch"
                                : item.radioVal === "1"
                                ? "scale"
                                : "fill",
                            style: _vm.radiusStyle,
                            attrs: { src: item.image },
                          })
                        : _c("div", { staticClass: "empty-box" }, [
                            _c("span", { staticClass: "iconfont icontupian" }),
                          ]),
                    ]
                  )
                })
              : _vm._e(),
            _vm.style === 1
              ? _c(
                  "div",
                  { staticClass: "advertItem02 acea-row", style: _vm.gapStyle },
                  _vm._l(_vm.picList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item",
                        style: _vm.spaceStyleTwo,
                      },
                      [
                        item.image
                          ? _c("img", {
                              staticClass: "img-style",
                              class:
                                item.radioVal === "0"
                                  ? "stretch"
                                  : item.radioVal === "1"
                                  ? "scale"
                                  : "fill",
                              style: _vm.radiusStyle,
                              attrs: { src: item.image },
                            })
                          : _c("div", { staticClass: "empty-box" }, [
                              _c("span", {
                                staticClass: "iconfont icontupian",
                              }),
                            ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.style === 2
              ? _c(
                  "div",
                  {
                    staticClass: "advertItem02 advertItem03 acea-row",
                    style: _vm.gapStyle,
                  },
                  _vm._l(_vm.picList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item",
                        style: _vm.spaceStyleThree,
                      },
                      [
                        item.image
                          ? _c("img", {
                              staticClass: "img-style",
                              class:
                                item.radioVal === "0"
                                  ? "stretch"
                                  : item.radioVal === "1"
                                  ? "scale"
                                  : "fill",
                              style: _vm.radiusStyle,
                              attrs: { src: item.image },
                            })
                          : _c("div", { staticClass: "empty-box" }, [
                              _c("span", {
                                staticClass: "iconfont icontupian",
                              }),
                            ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.style === 3
              ? _c(
                  "div",
                  { staticClass: "advertItem04 acea-row", style: _vm.gapStyle },
                  [
                    _c(
                      "div",
                      { staticClass: "item", style: _vm.spaceStyleTwo },
                      [
                        _vm.picList.length > 0 && _vm.picList[0].image
                          ? _c("img", {
                              staticClass: "img-style img-left",
                              class:
                                _vm.picList[0].radioVal === "0"
                                  ? "stretch"
                                  : _vm.picList[0].radioVal === "1"
                                  ? "scale"
                                  : "fill",
                              style: _vm.radiusStyle,
                              attrs: {
                                src:
                                  _vm.picList.length > 0 &&
                                  _vm.picList[0].image,
                              },
                            })
                          : _c("div", { staticClass: "empty-box" }, [
                              _c("span", {
                                staticClass: "iconfont icontupian",
                              }),
                            ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "item pic-four",
                        style: _vm.spaceStyleFour,
                      },
                      [
                        _c("div", { staticClass: "pic" }, [
                          _vm.picList.length > 1 && _vm.picList[1].image
                            ? _c("img", {
                                staticClass: "img-style",
                                class:
                                  _vm.picList[1].radioVal === "0"
                                    ? "stretch"
                                    : _vm.picList[1].radioVal === "1"
                                    ? "scale"
                                    : "fill",
                                style: _vm.radiusStyle,
                                attrs: {
                                  src:
                                    _vm.picList.length > 1 &&
                                    _vm.picList[1].image,
                                },
                              })
                            : _c("div", { staticClass: "empty-box" }, [
                                _c("span", {
                                  staticClass: "iconfont icontupian",
                                }),
                              ]),
                        ]),
                        _c("div", { staticClass: "pic" }, [
                          _vm.picList.length > 2 && _vm.picList[2].image
                            ? _c("img", {
                                staticClass: "img-style",
                                class:
                                  _vm.picList[2].radioVal === "0"
                                    ? "stretch"
                                    : _vm.picList[2].radioVal === "1"
                                    ? "scale"
                                    : "fill",
                                style: _vm.radiusStyle,
                                attrs: {
                                  src:
                                    _vm.picList.length > 2 &&
                                    _vm.picList[2].image,
                                },
                              })
                            : _c("div", { staticClass: "empty-box" }, [
                                _c("span", {
                                  staticClass: "iconfont icontupian",
                                }),
                              ]),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.style === 4
              ? _c(
                  "div",
                  {
                    staticClass: "advertItem02 advertItem05 acea-row",
                    style: _vm.gapStyle,
                  },
                  _vm._l(_vm.picList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item",
                        style: _vm.spaceStyleFive,
                      },
                      [
                        item.image
                          ? _c("img", {
                              staticClass: "img-style",
                              class:
                                item.radioVal === "0"
                                  ? "stretch"
                                  : item.radioVal === "1"
                                  ? "scale"
                                  : "fill",
                              style: _vm.radiusStyle,
                              attrs: { src: item.image },
                            })
                          : _c("div", { staticClass: "empty-box" }, [
                              _c("span", {
                                staticClass: "iconfont icontupian",
                              }),
                            ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.style === 5
              ? _c(
                  "div",
                  { staticClass: "advertItem06 acea-row", style: _vm.gapStyle },
                  _vm._l(_vm.picList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item",
                        style: _vm.spaceStyleTwo,
                      },
                      [
                        item.image
                          ? _c("img", {
                              staticClass: "img-style",
                              class:
                                item.radioVal === "0"
                                  ? "stretch"
                                  : item.radioVal === "1"
                                  ? "scale"
                                  : "fill",
                              style: _vm.radiusStyle,
                              attrs: { src: item.image },
                            })
                          : _c("div", { staticClass: "empty-box" }, [
                              _c("span", {
                                staticClass: "iconfont icontupian",
                              }),
                            ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }